// Globális user-select kikapcsolás, hogy ne lehessen semmilyen elemet, szöveget véletlenül sem kijelölni

import { is } from '../is/is'

const html = document.querySelector('html') as HTMLElement

html.style.userSelect = 'none'

const PREFIXES = [
  'webkit', // Chrome, Safari
  'Moz',    // FF
  'ms',     // IE
  'O'       // Opera
] as const

PREFIXES.forEach((prefix) => {
  const vendor = `${ prefix }UserSelect`

  if (is.property(html.style, vendor)) {
    html.style[vendor] = 'none'
  }
})
